import { render, staticRenderFns } from "./ButtonGroupEditor.vue?vue&type=template&id=513d379d&"
import script from "./ButtonGroupEditor.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports